import React from 'react';
import { MISSION_BLOCKS } from '../mock';
import { Target } from 'lucide-react';

export default function Missao() {
  return (
    <section className="relative w-full py-24 md:py-32 bg-[color:var(--sd-bg)]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 text-[color:var(--sd-cyan)] text-xs tracking-[0.35em] font-mono">
          <Target size={14} /> MISSÃO SQUARE DARTS BRASIL
        </div>
        <h2 className="mt-4 font-display font-black text-white text-3xl md:text-5xl tracking-widest">
          COMPETIR. CONECTAR. <span className="text-[color:var(--sd-cyan)] sd-glow">ELEVAR.</span>
        </h2>
        <div className="sd-rule mt-4 mb-10" />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {MISSION_BLOCKS.map((b) => (
            <div key={b.id} className="sd-panel sd-brackets p-6 md:p-8 min-h-[240px]">
              <div className="flex items-center justify-between mb-4">
                <div className="text-[10px] tracking-[0.3em] text-[color:var(--sd-cyan)]/70 font-mono">
                  // BLOCO 0{b.id}
                </div>
                <div className="h-px flex-1 ml-4 bg-[rgba(34,230,230,0.25)]" />
              </div>
              <h3 className="font-display text-white text-base md:text-lg font-bold tracking-[0.15em] leading-snug">
                {b.title}
              </h3>
              {b.items && (
                <ul className="mt-4 space-y-1.5 font-mono text-sm text-[color:var(--sd-text)]/85">
                  {b.items.map((i) => (
                    <li key={i}>. {i}</li>
                  ))}
                </ul>
              )}
              {b.subtitle && (
                <div className="mt-4">
                  <div className="font-display text-white text-sm font-bold tracking-[0.15em]">
                    {b.subtitle}
                  </div>
                  <ul className="mt-2 space-y-1.5 font-mono text-sm text-[color:var(--sd-text)]/85">
                    {b.subitems.map((i) => (
                      <li key={i}>. {i}</li>
                    ))}
                  </ul>
                </div>
              )}
              {b.description && (
                <p className="mt-4 font-mono text-sm text-[color:var(--sd-text)]/80 leading-relaxed">
                  {b.description}
                </p>
              )}
              {b.tag && (
                <div className="mt-6 text-[color:var(--sd-cyan)] font-mono text-sm tracking-[0.25em]">
                  {b.tag}
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-24 text-center relative">
          <div className="sd-rule mb-8" />
          <h3 className="font-display font-black text-white text-3xl md:text-6xl tracking-widest">
            DISPONÍVEL EM <span className="text-[color:var(--sd-cyan)] sd-glow">2027</span>
          </h3>
          <div className="sd-rule mt-8" />
          <div className="mt-6 text-xs tracking-[0.35em] text-[color:var(--sd-cyan)]/70 font-mono">
            [ COUNTDOWN INICIADO // PRE-LAUNCH PROGRAM ]
          </div>
        </div>
      </div>
    </section>
  );
}
